module.exports = __webpack_public_path__ + "static/img/park5.f61aaef.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/park5.jpg
// module id = ziIX
// module chunks = 1